import { useState, useEffect } from 'react';
import axios from 'packs/axios';

const handleError = error => {
  if (error) {
    return {
      success: false,
      error,
    };
  }
  return {
    success: false,
    data: { message: 'Network error' },
    status: 500,
    statusText: 'Network error',
  };
};

const useGET = (url, options = {}) => {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(url, options);

        if (response.status === 200) {
          setError(undefined);
          setData(response.data);
        }
      } catch (err) {
        setError(handleError(err.response));
      } finally {
        setLoading(false);
      }
    };

    if (url) {
      fetchData();
    }
  }, [url]);

  return { loading, data, error };
};

const usePOST = (url, body, options = {}) => {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.post(`${url}`, body, options);

        if (response.status === 200) {
          setData(response.data);
          setError(undefined);
        }
      } catch (err) {
        setError(handleError(err.response));
      } finally {
        setLoading(false);
      }
    };

    if (url) {
      fetchData();
    }
  }, [url]);

  return { loading, data, error };
};

const useMutation = (url, method = 'POST', options = {}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);

  const execute = async (body = null, configOverride = {}) => {
    setLoading(true);
    try {
      const response = await axios({
        url,
        method,
        data: body,
        ...options,
        ...configOverride,
      });
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { execute, loading, error };
};

const useHTTP = requestConfig => {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const { url } = requestConfig;

  const resetState = () => {
    setData(undefined);
    setError(undefined);
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios(requestConfig);
        if (response.status === 200) {
          setData(response.data);
        }
      } catch (err) {
        setError(handleError(err.response));
      } finally {
        setLoading(false);
      }
    };
    if (url) {
      fetchData();
    }
  }, [url]);

  return { loading, data, error, resetState };
};

export { useGET, usePOST, useMutation, useHTTP };
